import React from "react";
import './Content.scss'

const Content = ({ children }) => {
    return (React.createElement("div", { className: `content`}, children ));
};

export { Content as default };